import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-lg p-10 text-center" data-testid="payment-cancel">
        <div className="w-16 h-16 mx-auto rounded-full bg-stone-100 flex items-center justify-center mb-5">
          <XCircle className="w-10 h-10 text-stone-400" />
        </div>
        <h1 className="text-2xl font-bold text-stone-900 mb-2">결제가 취소되었습니다</h1>
        <p className="text-stone-500 text-sm mb-6">
          결제 진행이 중단되었습니다.<br />
          언제든지 다시 시도하실 수 있습니다.
        </p>
        <div className="flex flex-col gap-2">
          <Link to="/pricing">
            <Button className="w-full bg-burgundy-500 hover:bg-burgundy-600 text-white" data-testid="cancel-back-pricing">
              가격 페이지로 돌아가기
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full" data-testid="cancel-back-home">
              홈으로
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
